import { runInAction } from 'mobx'
import { deepToJS } from './deepToJS'

function assertReader<T>(reader: () => T, context: string) {
  if (typeof reader !== 'function') {
    throw new Error(`${context}: Reader must be a function`)
  }
}
// Reads a property of an object outside of a reaction/action
// This is useful when you know you want to read an observable/computed
// in an non-action non-reaction context.
// Great for non-mobx event handlers that need to read observables/computed values.
export function readOutsideReaction<T>(reader: () => T): T {
  assertReader(reader, 'readOutsideReaction')
  let value!: T

  runInAction(() => {
    value = reader()
  })

  return value
}

export function readMobxSnapshot<T>(reader: () => T): T {
  assertReader(reader, 'readMobxSnapshot')

  return readOutsideReaction(() => deepToJS(reader()))
}
